import { get } from 'lodash';

function fetchServiceTypes() {
  const token = get(window, 'uuSettings.api-key');
  if (!token) {
    console.warn('missing API key'); // eslint-disable-line
    return false;
  }
  const networkId = get(window, 'uuSettings.network-id');
  if (!networkId) {
    console.warn('missing network ID'); // eslint-disable-line
    return false;
  }

  const url = `${get(window, 'uuSettings.api-url', '')}networks/${networkId}/service_types`;

  const http = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        const resp = JSON.parse(http.responseText);

        if (resp.error) {
          reject(resp.error);
        } else {
          resolve(resp);
        }
      }
    };
    http.open('GET', `${url}?access_token=${token}`, true);
    http.setRequestHeader('Content-Type', 'application/json');
    http.send();
  });
}

export default fetchServiceTypes;



// WEBPACK FOOTER //
// ./public/js/actions/fetchServiceTypes.js